/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Paymid
 */
export class Paymid {
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    appKey: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    merchantAccountId: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    baseUrl: string;
    /**
     *
     * @type {string}
     * @memberof Paymid
     */
    type: string;
    /**
     *
     * @type {boolean}
     * @memberof Paymid
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Paymid
     */
    autoApprove: boolean;
}
